module.exports = __webpack_public_path__ + "img/logo-dark.7e7a25e7.png";